import React, {useState, useEffect} from 'react';
import "./slider.css";

const slider = {
  slides: [
    `/images/slider1.png`,
    `/images/slider2.jpg`,
    `/images/slider3.jpg`,
    `/images/slider4.jpg`,
    `/images/slider5.jpg`,
    `/images/slider6.jpg`,
    `/images/slider7.jpg`,
    `/images/slider8.jpg`,
    `/images/slider9.jpg`,
  ],
  messages: [
    "#Running",
    "#Beach Volley",
    "#Cycling",
    "#Basketball",
    "#Beach Volley",
    "#Triathlon",
    "#Hockey",
    "#Rugby",
    "#Skiing",
  ],
};

const Slider: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [fading, setFading] = useState(false);

  const goTo = (next: number) => {
    if (fading) return;
    setPrev(current);
    setCurrent(next);
    setFading(true);
    setTimeout(() => {
      setPrev(null);
      setFading(false);
    }, 600);
  };

  const sliderLeft = () => {
    goTo((current - 1 + slider.slides.length) % slider.slides.length);
  };

  const sliderRight = () => {
    goTo((current + 1) % slider.slides.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goTo(((prev !== null ? current : current) + 1) % slider.slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [current, prev]);

  return (
    <div id="main">
      {prev !== null && (
        <div
          className="slider-slide slider-slide-out"
          style={{ backgroundImage: `url(${slider.slides[prev]})` }}
        >
          <div className="slider-text-container">
            <span className="slider-text">{slider.messages[prev]}</span>
          </div>
        </div>
      )}
      <div
        className={`slider-slide ${fading ? 'slider-slide-in' : ''}`}
        style={{ backgroundImage: `url(${slider.slides[current]})` }}
      >
        <div className="slider-text-container">
          <span className="slider-text">{slider.messages[current]}</span>
        </div>
      </div>

      <button className="slider-arrow slider-arrow-left" onClick={sliderLeft} aria-label="Previous slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <button className="slider-arrow slider-arrow-right" onClick={sliderRight} aria-label="Next slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 6 15 12 9 18"/>
        </svg>
      </button>

      <div className="slider-dots">
        {slider.slides.map((_, i) => (
          <button
            key={i}
            className={`slider-dot ${i === current ? 'slider-dot-active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;